<quotely-navbar></quotely-navbar>
<router-outlet></router-outlet>
<quotely-footer></quotely-footer>
